// =============================================================================
// Profile action constants — Phase 2.
//
// Hydration lifecycle (one-shot, fired by bootstrapApp):
//   PROFILE_HYDRATION_PENDING         — fetch in flight
//   PROFILE_HYDRATION_SUCCESS         — fetch returned, data available
//   PROFILE_HYDRATION_FAILED          — fetch errored; data may be stale or null
//   PROFILE_HYDRATION_UNAUTHENTICATED — no auth at bootstrap; nothing to fetch
//
// Phase 4 will add per-mutation actions (PROFILE_UPDATE_SUCCESS, PROFILE_RESET).
// =============================================================================

export const PROFILE_HYDRATION_PENDING = 'PROFILE_HYDRATION_PENDING';
export const PROFILE_HYDRATION_SUCCESS = 'PROFILE_HYDRATION_SUCCESS';
export const PROFILE_HYDRATION_FAILED = 'PROFILE_HYDRATION_FAILED';
export const PROFILE_HYDRATION_UNAUTHENTICATED = 'PROFILE_HYDRATION_UNAUTHENTICATED';
